{
  "en": {
    "todo_list": {
      "actions": {
        "add": "Create Task List",
        "cancel": "Undo",
        "delete_todo_list": "Delete List",
        "edit": "Edit Task List",
        "new": "Task List",
        "save": "Save",
        "title": "List title"
      },
      "attributes": {
        "name": "Title"
      },
      "labels": {
        "assignToLevel": "Assign to level",
        "createdAt": "Created at",
        "filter_employee": "Responsible",
        "newTodoList": "New task list",
        "sort": {
          "created_at_asc": "Oldest first",
          "created_at_desc": "Newest first",
          "name_lower_asc": "Title A -> Z",
          "name_lower_desc": "Title Z -> A"
        }
      },
      "phase_out": {
        "body": "Tasks (legacy) stops at the end of 2026. Migrate any tasks you still need to Tasks before 1 January 2027. You can keep using and completing existing tasks until then.",
        "title": "Tasks (legacy) is being retired"
      },
      "placeholders": {
        "empty": "No task lists here"
      },
      "toasts": {
        "create": "Task list successfully created",
        "delete": "Task list has been successfully deleted",
        "update": "Task list has been successfully updated"
      },
      "validation": {
        "needTitle": "Title required"
      }
    }
  }
}
